require("flatpickr/dist/themes/airbnb.css")

import "./controllers"
import flatpickr from "flatpickr"
import 'flowbite'
import "@fortawesome/fontawesome-free/js/all"
import "@hotwired/turbo-rails"
import { StreamActions } from "@hotwired/turbo"

// Register custom Turbo Stream action for decrementing count
StreamActions["decrement-count"] = function() {
  const controller = this.targetElements[0]
  if (controller) {
    const event = new CustomEvent("decrement-count", { bubbles: true })
    controller.dispatchEvent(event)
  }
}

// Reinitialize Flowbite dropdowns after Turbo navigation
document.addEventListener('turbo:load', () => {
  if (window.initFlowbite) {
    window.initFlowbite()
  }
})

document.addEventListener('turbo:render', () => {
  if (window.initFlowbite) {
    window.initFlowbite()
  }
})
